import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css';
import FolderTreeTheme from './theme/index';


const FolderTree = ({
  treeData, width, height, ...other
}) => (
  <div style={{ height, width }}>
    <SortableTree
      theme={FolderTreeTheme}
      treeData={treeData}
      onChange={() => {}}
      scaffoldBlockPxWidth={22}
      rowHeight={55}
      isVirtualized={false}
      {...other}
    />
  </div>
);
FolderTree.propTypes = {
  treeData: PropTypes.arrayOf(PropTypes.object).isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
};
FolderTree.defaultProps = {
  height: 'auto',
  width: 'auto',
};

export default styled(FolderTree)`
  .rst__placeholder {
    height: 0;
    padding: 0;
  }
  .rst__placeholder::before {
    border: 0;
  }
`;
